import React, { useEffect } from 'react';
import { i18n } from '@factorin/container.macro';

import { ChainedRender } from 'Modules/core/react';
import { useAction } from 'Modules/core/redux';
import { storageActions } from 'Modules/business/data';


const useChangeLanguage = () => {
    useEffect(
        () => {
            i18n.changeLanguage('ru');
        },
        [],
    );
};

export const InitializeRender: ChainedRender = ({ Next }) => {
    const initialize = useAction(storageActions.initialize, []);
    useChangeLanguage();
    useEffect(
        () => {
            initialize();
        },
        [initialize],
    );

    return <Next />;
};
